import React from 'react';
import { Skeleton } from '@progress/kendo-react-indicators';

const GridLoader = () => (
  <div className='grid-loader'>
    <div>
      <Skeleton shape="rectangle" style={{ height: '5em' }} />
      <Skeleton shape="rectangle" style={{ height: '5em' }} />
      <Skeleton shape="rectangle" style={{ height: '5em' }} />
      <Skeleton shape="rectangle" style={{ height: '5em' }} />
      <Skeleton shape="rectangle" style={{ height: '5em' }} />
    </div>
    <div>
      <Skeleton shape="rectangle" style={{ height: '125px' }} />
      <Skeleton shape="rectangle" style={{ height: '125px' }} />
      <Skeleton shape="rectangle" style={{ height: '125px' }} />
      <Skeleton shape="rectangle" style={{ height: '125px' }} />
      <Skeleton shape="rectangle" style={{ height: '125px' }} />
    </div>
  </div>
);

export default GridLoader;
